import React, { useState, useEffect } from "react";
import { Drawer, Spin, Button, message } from "antd";
import moment from "moment";
import { getConversationDetail } from "../../../services/polly/classificationService";
import ReassignModal from "./ReassignModal";

export default function ConversationDrawer({ visible, conversationId, flatTopics, onClose, onReassignSuccess }) {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reassignVisible, setReassignVisible] = useState(false);

  useEffect(() => {
    if (!visible || !conversationId) {
      setDetail(null);
      return;
    }
    setLoading(true);
    getConversationDetail(conversationId)
      .then((res) => setDetail(res))
      .catch((err) => {
        console.warn("Failed to load conversation detail:", err);
        message.error("Failed to load conversation");
      })
      .finally(() => setLoading(false));
  }, [visible, conversationId]);

  const handleReassignSuccess = () => {
    setReassignVisible(false);
    message.success("Conversation reassigned");
    onReassignSuccess && onReassignSuccess();
    onClose();
  };

  const confidenceColor = (c) => {
    if (c >= 75) return '#3B6D11';
    if (c >= 50) return '#BA7517';
    return '#E24B4C';
  };

  return (
    <>
      <Drawer
        title="Conversation Detail"
        placement="right"
        width={480}
        visible={visible}
        onClose={onClose}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button type="default" onClick={() => setReassignVisible(true)}>
              Reassign
            </Button>
          </div>
        }
      >
        <Spin spinning={loading}>
          {detail && (
            <>
              <div className="conversation-detail-section" style={{ borderTop: 'none', paddingTop: 0, marginTop: 0 }}>
                <h4>Classification</h4>
                <div className="conversation-detail-row">
                  <span className="conversation-detail-label">Topic</span>
                  <span className="conversation-detail-value">{detail.topicName}</span>
                </div>
                <div className="conversation-detail-row">
                  <span className="conversation-detail-label">Confidence</span>
                  <span
                    className="conversation-detail-value"
                    style={{ color: confidenceColor(detail.confidence) }}
                  >
                    {detail.confidence}%
                  </span>
                </div>
                <div className="conversation-detail-row">
                  <span className="conversation-detail-label">Classified at</span>
                  <span className="conversation-detail-value">
                    {detail.classifiedAt ? moment(detail.classifiedAt).format("MMM D, YYYY h:mm a") : '-'}
                  </span>
                </div>
              </div>

              <div className="conversation-thread-section">
                <h4>Conversation</h4>
                <div className="conversation-drawer-thread">
                  {(detail.messages || []).map((msg) => (
                    <div key={msg.id} className={`conversation-message-row ${msg.direction}`}>
                      <div className="conversation-message-role">
                        {msg.direction === 'outbound' ? 'Customer' : 'Polly'}
                      </div>
                      <div className={`conversation-message ${msg.direction}`}>
                        {msg.content}
                      </div>
                      <div className="conversation-message-time">
                        {msg.sentAt ? moment(msg.sentAt).format("MMM D, h:mm a") : ''}
                      </div>
                    </div>
                  ))}
                  {(!detail.messages || detail.messages.length === 0) && (
                    <div style={{ color: '#999', fontSize: 12 }}>No messages available</div>
                  )}
                </div>
              </div>
            </>
          )}
          {!loading && !detail && (
            <div style={{ textAlign: 'center', color: '#888', padding: 40 }}>
              No conversation data available
            </div>
          )}
        </Spin>
      </Drawer>

      <ReassignModal
        visible={reassignVisible}
        conversationId={conversationId}
        flatTopics={flatTopics}
        onCancel={() => setReassignVisible(false)}
        onSuccess={handleReassignSuccess}
      />
    </>
  );
}
